import React from 'react'

const Admin_fees_paid = () => {
  return <div>Admin_fees_paid</div>
}

export default Admin_fees_paid
